import { PlayerSummary } from '@inplay/models';

export type NewPlayerImages = {
  portraitImage: string;
  fullBodyImage: string;
};

export enum PlayerType {
  NewPlayer = 'newPlayer',
  ExistingPlayer = 'existingPlayer',
}

export type PlayerCardProps = {
  style?: string;
  player: PlayerSummary;
  selectedPlayer?: PlayerSummary;
  onClick?: (player: PlayerSummary) => void;
};

export type SelectPlayerProps = {
  onClose: () => void;
  onProceed: (
    selectedPlayer: PlayerSummary | NewPlayerImages,
    playerType: PlayerType,
  ) => void;
};

export type ExistingPlayerProps = {
  playerLoading: boolean;
  query: string;
  setQuery: (value: string) => void;
  filteredPlayers: PlayerSummary[];
  selectedPlayer?: PlayerSummary;
  setSelectedPlayer: (player: PlayerSummary) => void;
};

export type NewPlayerProps = {
  images: NewPlayerImages;
  setImages: React.Dispatch<React.SetStateAction<NewPlayerImages>>;
};

export enum ImageType {
  Portrait = 'portraitImage',
  FullBody = 'fullBodyImage',
}

export enum DropdownMenuAction {
  Replace = 'replace',
  Delete = 'delete',
}
